<template>
    <div class="horizFlex">

        <giftcardbalance :showButton="trueParam" v-if="showGiftcard" buttonClass="shortbutton"/>
        <accountbalance :showButton="trueParam" v-if="showAccount" buttonClass="shortbutton"/>
    </div>
          

  </template>
  
  <script>
   import {mapFields} from 'vuex-map-fields'
   import giftcardbalance from '../actions/giftcardbalance.vue'
   import accountbalance from '../actions/accountbalance.vue'
   import pos from '../../services/pos.js'
  export default {
      name:'footer_culinary',
      components:{

          giftcardbalance,
          accountbalance,

      },
       mixins:[pos],
      computed:{
          ...mapFields([

          ]),
          

      },
      data(){
          return{
              
              falseParam:false,
              trueParam:true
          }
      },
      methods:{

        
      },

  }
  </script>
  
  <style>
 
      .shortbutton{
        border: none;
        border-radius:10px;
        width:135px;
        height:40px;
        padding:0px;
        font-size: medium;
        margin:10px;
        text-decoration: none;
        background-color:var( --button-color);
        color:var(--button-text-color);
  
      }
      .footerclass{

      }
  </style>